import SiteSuspended from "./components/SiteSuspended";

function App() {
  return <SiteSuspended />;
}

export default App;
